export const SchoolFooter = () => {
    const socialLinks = [
        { name: "Facebook", icon: "fab fa-facebook", url: "https://www.facebook.com/groups/177927672231707" },
        { name: "Twitter", icon: "fab fa-twitter", url: "https://x.com/SSGK1966" },
        {
          name: "Instagram",
          icon: "fab fa-instagram",
          url: "https://www.instagram.com/explore/locations/1579454688960191/old-boys-association--sainik-school-ghorakhal/",
        },
        { name: "LinkedIn", icon: "fab fa-linkedin", url: "https://www.linkedin.com/school/sainik-school-ghorakhal" },
      ]
    return ( <footer className="bg-slate-800 text-white">
        <div className="max-w-7xl mx-auto px-4 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h3 className="text-lg font-semibold mb-4">Connect With Us</h3>
              <div className="flex space-x-4">
                {socialLinks.map((link) => (
                  <a
                    key={link.name}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transform transition-transform hover:scale-110 hover:text-blue-400"
                  >
                    <i className={`${link.icon} text-2xl`}></i>
                  </a>
                ))}
              </div>
            </div>




          </div>

          <div className="border-t border-slate-700 mt-8 pt-8 text-center text-sm text-gray-400">
            <p>
              © {new Date().getFullYear()} Sainik School, Ghorakhal, OBA. All rights reserved.
            </p>
          </div>
        </div>
      </footer>)
}